export const expertPreviousPlanSkeletonCard_style = {
  cardRootSx: {
    borderRadius: '8px',
    border: '1px solid #E3E3E3',
  },
};
